import CreateFilingButton from "../../../components/CreateFilingButton";
import UploadFilingButton from "../../../components/UploadFilingButton";
import { Button } from "../../../design/button";
import { Heading } from "../../../design/heading";
import { Input } from "../../../design/input";
import { Text } from "../../../design/text";

export const FilingsExplainerCard: React.FC = () => {
  return (
    <div className="flex flex-col gap-4 p-6 bg-gray-100 border shadow-sm rounded-xl dark:bg-zinc-900">
      {/* Header */}
      <div>
        <Heading>Build, Break Down, and Respond to Legal Filings</Heading>
        <Text>
          Upload a legal document to break it into sections automatically — or
          start from scratch and build a filing step-by-step with your team.
        </Text>
      </div>

      {/* Main content */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        {/* Upload a Document */}
        <div className="flex flex-col gap-4 p-6 bg-white border shadow-sm dark:bg-black rounded-xl">
          <div>
            <Heading>📄 Upload a Legal Document</Heading>
            <Text>
              Upload court filings, motions, complaints, or any legal document.
              We’ll automatically break it into sections for review and
              collaboration.
            </Text>
            {/* <a href="/sample-filing" style={{ textDecoration: "underline", fontSize: "1rem", color: "#2c7be5" }}>
                View a sample filing
            </a> */}
          </div>
          <UploadFilingButton>Upload and Analyze Filing</UploadFilingButton>
        </div>

        {/* Start from Scratch */}
        <div className="flex flex-col gap-4 p-6 bg-white border shadow-sm radius-2xl">
          <div>
            <Heading>✏️ Start from Scratch</Heading>
            <Text>
              Build a filing manually by creating sections and adding notes
              directly. Perfect for planning responses, drafting new filings, or
              collaborating with your team before submission.
            </Text>
          </div>
          <CreateFilingButton>Start a New Filing</CreateFilingButton>
        </div>
      </div>
    </div>
  );
};
